import { useEnvContext } from "context/EnvContext";
import { APP_KIND } from "core/consts";
import {
  buildAppUrl,
  getAppRoutePrefix,
} from "core/model/utils/urls/getBaseUrl";
import { AppType, Env } from "core/types";
import { HorizontalLayout } from "ds_legacy/materials/layouts";
import { margin } from "ds_legacy/materials/metrics";
import { Badge, Link } from "ds_legacy/materials/typography";
import styled from "styled-components";

const StyledAppList = styled(HorizontalLayout)`
  justify-content: flex-end;
  & > * + * {
    margin-left: ${margin(0.5)};
    &:before {
      content: " | ";
    }
  }
`;

const APP_URLS: Map<
  AppType,
  {
    href: string;
    label: string;
  }
> = new Map([
  [APP_KIND.APP_CLINIC, { href: "/", label: "Careseeker" }],
  [APP_KIND.APP_CAREPROVIDER, { href: "/careprovider", label: "Careprovider" }],
  [APP_KIND.APP_ACP, { href: "/acp", label: "ACP" }],
  [
    APP_KIND.APP_PROVIDER_SEARCH,
    { href: "/providersearch", label: "Provider Search" },
  ],
]);

export function setCurrentAppOptions({
  currentApp,
  env,
}: {
  currentApp: AppType;
  env: Env;
}) {
  const appOptions = new Map(APP_URLS);
  appOptions.delete(currentApp);

  return Array.from(appOptions, ([app, { label }]) => ({
    href: buildAppUrl({ app, env, path: getAppRoutePrefix(app) }),
    label,
  }));
}

export default function LoginSuggestions() {
  const { env } = useEnvContext();
  const { app: currentApp } = useEnvContext();
  const appOptions = setCurrentAppOptions({ currentApp, env });
  const host = window.location.host;
  if (!host.includes("localhost")) return null;

  return (
    <div style={{ margin: margin(0, 1, -2) }}>
      <StyledAppList>
        {appOptions.map(({ href, label }, index) => (
          <Badge key={index}>
            <Link href={href}>{label}</Link>
          </Badge>
        ))}
      </StyledAppList>
    </div>
  );
}
